import React from 'react';

function LoadingOverlay({ message = 'Analyzing images…' }) {
  return (
    <div className="loading-overlay" role="status" aria-live="polite">
      <div className="spinner" />
      <p>{message}</p>
    </div>
  );
}

export default LoadingOverlay;
